import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { getTheme, ThemeStyle, ThemeMode } from "../styles/theme";

interface ThemeContextProps {
  themeStyle: ThemeStyle;
  themeMode: ThemeMode;
  setThemeStyle: (style: ThemeStyle) => void;
  setThemeMode: (mode: ThemeMode) => void;
}

const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeContext must be used within a ThemeProvider");
  }
  return context;
};

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [themeStyle, setThemeStyle] = useState<ThemeStyle>(() => {
    return (localStorage.getItem("theme_style") as ThemeStyle) || "corporate";
  });

  const [themeMode, setThemeMode] = useState<ThemeMode>(() => {
    return (localStorage.getItem("theme_mode") as ThemeMode) || "light";
  });

  useEffect(() => {
    localStorage.setItem("theme_style", themeStyle);
  }, [themeStyle]);

  useEffect(() => {
    localStorage.setItem("theme_mode", themeMode);
  }, [themeMode]);

  return (
    <ThemeContext.Provider
      value={{ themeStyle, themeMode, setThemeStyle, setThemeMode }}
    >
      <EmotionThemeProvider theme={getTheme(themeStyle, themeMode)}>
        {children}
      </EmotionThemeProvider>
    </ThemeContext.Provider>
  );
};
